<template>
  <div
    class="email-queue-footer"
  >
    <p
      class="alert alert-warning text-center fixed-bottom"
      v-if="!email.isQueued"
      style="margin-bottom: 0"
    >
      This {{ emailType }} has not been queued yet!
      <button
        class="btn btn-sm btn-danger ml-1"
        v-on:click="queue"
        v-if="!hideQueue"
      >
        Queue
      </button>
    </p>
  </div>
</template>
<script>
import EmailMixin from '@/mixins/EmailMixin'

export default {
  props: {
    emailType: {
      type: String,
      default: 'newsletter'
    },

    hideQueue: {
      type: Boolean,
      default: false
    }
  },

  mixins: [
    EmailMixin
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/EmailQueueFooter.vue